import React from 'react';
import { formatCurrency } from '../../utils/formatters';

const OutputCell = ({ label, value, unit, formatter = (v) => formatCurrency(v) }) => (
    <div className="grid grid-cols-2 gap-4 items-center py-2 px-3">
        <span className="text-sm font-medium text-gray-700 dark:text-gray-300">{label}</span>
        <div className="flex justify-end items-center space-x-2">
            <span className="text-sm font-semibold text-gray-900 dark:text-gray-100 bg-gray-100 dark:bg-gray-700 px-3 py-1.5 rounded-md w-full text-right">{formatter(value)}</span>
            {unit && <span className="text-sm text-gray-500 dark:text-gray-400 w-24">{unit}</span>}
        </div>
    </div>
);

export default OutputCell; 